import { defineMessages } from 'react-intl';

type MessageKeys = 'clearAllSelectedItemsButtonText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		clearAllSelectedItemsButtonText: {
			id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
			defaultMessage: 'Clear selection',
			description: 'Clicking this button will unselect all the selected items in the dropdown',
		},
	});

export default message;
